// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_H6X","delete":"styles_delete__17Xj1","update":"styles_update__2zhHd","add":"styles_add__2j_e-"};